import { useT } from '@/i18n/runtime';
import { Icon } from './Icon';

type PillKind = 'secure' | 'verified' | 'queue';

interface SecurePillProps {
  kind?: PillKind;
  label?: string;
}

/** The small trust pill in the app bar. 'queue' variant uses the --wait token. */
export function SecurePill({ kind = 'secure', label }: SecurePillProps): JSX.Element {
  // VC-12: the default words come from the deck (the RTL probe caught an English "Secure" on the Arabic landing)
  const { t } = useT();
  if (kind === 'queue') {
    return (
      <span className="secure-pill is-queue">
        <span className="live-dot" />
        {label ?? t('droom.pill.queue')}
      </span>
    );
  }
  if (kind === 'verified') {
    return (
      <span className="secure-pill">
        <Icon name="shield" size={13} />
        {label ?? t('droom.pill.verified')}
      </span>
    );
  }
  return (
    <span className="secure-pill">
      <Icon name="lock" size={13} />
      {label ?? t('droom.pill.secure')}
    </span>
  );
}
